<div [formGroup]="parentForm">
  <input [formControlName]="field?.controlName" [id]="field?.controlName" type="hidden" tabindex="0" />
  <span
    (click)="canEdit ? openValueEditorDialog() : null"
    (keydown.enter)="canEdit ? openValueEditorDialog() : null"
    [attr.tabindex]="canEdit ? 0 : null"
    [attr.role]="canEdit ? 'button' : null"
    class="fd-fee-editor__display-value"
    [ngClass]="{
      'fd-fee-editor__display-value--edited': feeColor === 'green' || field?.isEdited,
      'fd-fee-editor__display-value--read-only': !canEdit,
      'fd-fee-editor__display-value--initial': feeColor === 'blue' && !field?.isEdited && canEdit
    }"
    >{{ displayValue }}%</span
  >
</div>
